import _toConsumableArray from "/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var t = Symbol(),
    e = Symbol(),
    r = Symbol(),
    n = Object.getPrototypeOf,
    s = new WeakMap(),
    o = function o(t) {
  return t && (n(t) === Object.prototype || n(t) === Array.prototype || !!s.get(t));
},
    i = function i(t) {
  return "object" == typeof t && null !== t;
},
    c = function c(n) {
  var s = {
    o: n,
    t: !1,
    r: function r(t) {
      if (!this.t) {
        var _e = this.a.get(this.o);

        _e || (_e = new Set(), this.a.set(this.o, _e)), _e.add(t);
      }
    },
    u: function u() {
      this.t = !0, this.a.delete(this.o);
    },
    get: function get(t, e) {
      return e === r ? this.o : (this.r(e), l(t[e], this.a, this.c));
    },
    has: function has(t, r) {
      return r === e ? (this.u(), !0) : (this.r(r), r in t);
    },
    ownKeys: function ownKeys(e) {
      return this.r(t), Reflect.ownKeys(e);
    }
  };
  return Object.isFrozen(n) && (s.set = s.deleteProperty = function () {
    return !1;
  }), s;
},
    l = function l(t, e, s) {
  if (!o(t)) return t;
  var i = t[r] || t;
  var l = s && s.get(i);
  return l || (l = c(i), l.p = new Proxy(function (t) {
    return Object.isFrozen(t) ? Array.isArray(t) ? Array.from(t) : Object.create(n(t), function (t) {
      var e = Object.getOwnPropertyDescriptors(t);
      return Object.values(e).forEach(function (t) {
        t.configurable = !0;
      }), e;
    }(t)) : t;
  }(i), l), s && s.set(i, l)), l.a = e, l.c = s, l.p;
},
    u = function u(t, e) {
  var r = Reflect.ownKeys(t),
      n = Reflect.ownKeys(e);
  return r.length !== n.length || r.some(function (t, e) {
    return t !== n[e];
  });
},
    h = 1,
    a = 2,
    f = 4,
    y = 8,
    g = function g(e, r, n, s) {
  var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  if (Object.is(e, r) && (!i(e) || 0 == (2 & o))) return !1;
  if (!i(e) || !i(r)) return !0;
  var c = n.get(e);
  if (!c) return 0 == (1 & o);

  if (s && 0 == (2 & o)) {
    var _t = s.get(e);

    if (_t && _t.n === r) return _t.g;
    s.set(e, {
      n: r,
      g: !1
    });
  }

  var l = null;

  var _iterator = _createForOfIteratorHelper(c),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _i = _step.value;

      var _c = _i === t ? u(e, r) : g(e[_i], r[_i], n, s, o >>> 2 << 2 | o >>> 2);

      if (!0 !== _c && !1 !== _c || (l = _c), l) break;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null === l && (l = 0 == (1 & o)), s && 0 == (2 & o) && s.set(e, {
    n: r,
    g: l
  }), l;
},
    b = function b(t) {
  return !!o(t) && e in t;
},
    p = function p(t) {
  return o(t) && t[r] || null;
},
    O = function O(t) {
  s.set(t, !0);
},
    j = function j(t, e) {
  var r = [],
      n = function n(t, s) {
    var o = e.get(t);
    o ? o.forEach(function (e) {
      n(t[e], s ? [].concat(_toConsumableArray(s), [e]) : [e]);
    }) : s && r.push(s);
  };

  return n(t), r;
};

export { h as MODE_ASSUME_UNCHANGED_IF_UNAFFECTED, f as MODE_ASSUME_UNCHANGED_IF_UNAFFECTED_IN_DEEP, a as MODE_IGNORE_REF_EQUALITY, y as MODE_IGNORE_REF_EQUALITY_IN_DEEP, j as affectedToPathList, l as createDeepProxy, p as getUntrackedObject, g as isDeepChanged, O as markToTrack, b as trackMemo };